import React from 'react'
import { useNavigate } from 'react-router-dom';
export default function PageNotFound() {
    let navigate = useNavigate();
  return (
    <center>
        <div style={{textAlign: 'center',marginTop: '22px',fontSize: '32px',fontWeight: '700'}}>404 Page Not Found</div>
        <button onClick={()=> navigate('/quiz')}>Back To Home</button>
    </center>
  )
}
